import { FaCheck } from 'react-icons/fa';

const labelWeatherComponent = ({ text, wsmode, index, onClick }) => {
  return (
    <label class='custom-radio' onClick={onClick}>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <p>{wsmode === index ? <FaCheck /> : ''}</p>
        <p style={{ paddingLeft: '15px' }}>{text}</p>
      </div>
    </label>
  );
};

export default labelWeatherComponent;
